import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { checkIsType } from '@src/framework/workbench/drawer/utils';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IItems } from '../form.interface';

/**
 * 获取group-model需要置灰的设置项。
 * @param model 所选元素
 * @returns
 */
export const getGroupDisabledItems = (model: IGroupModel): IItems => ({
    // TODO 连接线暂不支持锁定纵横比
    [FormItemName.SIZE_ADJUST]: () => checkIsType(model, UIModelType.CONNECTOR),
    // 幻灯片最佳放映比例，组合置灰
    [FormItemName.BEST_PLAY_SCALE]: () => true,
    // 相对图片原始尺寸，组合置灰
    [FormItemName.RELATIVE_IMAGE_ORIGINAL_SIZE]: () => true,
    [FormItemName.PICTURE_POSITIOIN_WIDTH]: () => true,
    [FormItemName.PICTURE_POSITIOIN_HEIGHT]: () => true,
    [FormItemName.PICTURE_POSITIOIN_OFFSET_X]: () => true,
    [FormItemName.PICTURE_POSITIOIN_OFFSET_Y]: () => true,
    [FormItemName.CROP_POSITIOIN_WIDTH]: () => true,
    [FormItemName.CROP_POSITIOIN_HEIGHT]: () => true,
    [FormItemName.CROP_POSITIOIN_LEFT]: () => true,
    [FormItemName.CROP_POSITIOIN_TOP]: () => true,
});
